<table
  class="data-table w-100"
  mat-table
  [dataSource]="dataSource"
  matSort
  matSortStart="desc"
>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell text-center p-2" [colSpan]="displayedColumns.length">
      <span *ngIf="worklistItems?.length === 0 && !filtersApplied"
        >No orders are available for viewing.</span
      >
      <span *ngIf="worklistItems?.length === 0 && filtersApplied"
        >No orders match the applied filters.</span
      >
      <span *ngIf="!worklistItems">Loading...</span>
    </td>
  </tr>
  <ng-container matColumnDef="urgency">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-urgency"
    >
      <div class="p-2 ml-2">Urgency</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2 ml-2">{{ getUrgencyDescription(row.urgency) }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-status"
    >
      <div class="p-2">Status</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2">{{ getStatusDescription(row.status) }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="mrn">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-mrn"
    >
      <div class="p-2">MRN</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2 break-word">{{ row.mrn }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="patientName">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-patientName"
    >
      <div class="p-2">Patient Name</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2">{{ row.patientName }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="studyDateTime">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-studyDateTime"
    >
      <div class="p-2">Study Date Time</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2">{{ formatStudyDateTime(row.studyDateTime) }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="imageCount">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      id="worklist-column-imageCount"
    >
      <div class="p-2 text-center">Image Count</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2 d-flex justify-content-center">
        <span class="">{{ adjustImageCount(row.noOfImagesArrived) }}</span>
        <span class="mx-1"> / </span>
        <span class="">{{ adjustImageCount(row.noOfImagesExpected) }}</span>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="studyDescription">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-studyDescription"
    >
      <div class="p-2">Study Description</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2">{{ row.studyDescription }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="modality">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-modality"
    >
      <div class="p-2">Modality</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2">{{ row.modality }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="referringDoctor">
    <th
      scope="col"
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      id="worklist-column-referringDoctor"
    >
      <div class="p-2">Referring Clinician</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2">{{ row.referringDoctor }}</div>
    </td>
  </ng-container>
  <ng-container matColumnDef="info">
    <th mat-header-cell *matHeaderCellDef>
      <div class="p-2">{{ getItemCount() }}</div>
    </th>
    <td mat-cell *matCellDef="let row">
      <div class="p-2 d-flex justify-content-end">
        <mat-icon *ngIf="hasMissingFields(row)" color="primary" class="mr-2"
          >warning</mat-icon
        >
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    class="clickable"
    [ngClass]="getClass(row)"
    (click)="onOpenRow(row)"
  ></tr>
</table>
<div class="d-flex">
  <div class="mx-auto my-3" *ngIf="showLoadMore">
    <button mat-stroked-button (click)="loadMore()">Load More</button>
  </div>
</div>
<mat-paginator
  [ngStyle]="{ display: 'none' }"
  [pageSize]="INITIAL_PAGE_SIZE"
></mat-paginator>
